module.exports = __webpack_public_path__ + "static/media/signinbg.8028a1e3.png";